import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import { DragHandleOutlined } from '@mui/icons-material';
import ServiciosTabla from '../types/ServiciosTabla';
import ServiciosEditar from '../types/ServiciosEditar';
import ObtenerServicios from '../functions/ObtenerServicios';

interface ListarServiciosProps {
    defaultItemsPerPage?: number;
    handleEdit: (servicio: ServiciosEditar) => void;
    handleDelete: (servicio: ServiciosEditar) => void;
    handleAdd: () => void
}

export const ListarServicios: React.FC<ListarServiciosProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, }) => {
  
  const [Servicios, setServicios] = useState<ServiciosEditar[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  useEffect(() => {
    const fetchServicios = async () => {
      try {
        const data = await ObtenerServicios();
        setServicios(data.servicios);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los Servicios:' + err);
        setLoading(false);
      }
    };

    fetchServicios();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'nombre', label: 'Servicio', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'mostrar_web', label: 'MOSTRAR EN WEB', align: 'center' as const },
    { key: 'dado_de_baja', label: 'DADO DE BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (servicio: ServiciosEditar) => {
    handleEdit(servicio);
  };

  const handleDeleteLocal = (servicio: ServiciosEditar) => {
    handleDelete(servicio);
  };

  const handleCredencialLocal = (servicio: ServiciosEditar) => {
    console.log('Mostrar credencial', servicio);
  }

  const handleUbicationLocal = (servicio: ServiciosEditar) => {
    console.log('Mostrar ubicacion', servicio);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Servicios cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nuevo Servicio</button>
        </div>
      </div>
      <Tabla columns={columns} data={Servicios} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleCredencialLocal} onUbication={handleUbicationLocal} acciones={['editar','eliminar']}/>
    </div>
  );
};